<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">{{title! | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col">
            <h5>{{description! | translate}}</h5>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{ chiudi }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="confirm()">{{ conferma | translate }}</button>
</div>